export default {
  name: "区域",
  url: "/admin/memorial-tablet-region", // rest接口表名
  query: "&expand=count", // rest接口query参数
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { title: "区域名称", dataIndex: "name" },
      { title: "H5首页介绍", dataIndex: "info" },
      { title: "区块数量", dataIndex: "count" },
    ];
  },
  searchKeyType: {
    name: 1,
  },
  // 列表查询表单
  queryForm: [
    {
      key: "name",
      label: "区域名称",
      component: "a-input",
      props: {
        placeholder: "输入区域名称查询",
        allowClear: true,
      },
    },
  ],
  // 新增/编辑查询表单
  items: [
    {
      key: "name",
      label: "区域名称",
      component: "a-input",
      props: {
        placeholder: "请输入区域名称",
        allowClear: true,
      },
      rules: [{ required: true, message: "请输入区域名称", trigger: "blur" }],
    },
    {
      key: "info",
      label: "H5首页介绍",
      component: "a-input",
      props: {
        placeholder: "请输入H5首页介绍",
        allowClear: true,
      },
      rules: [{ required: true, message: "请输入H5首页介绍", trigger: "blur" }],
    },
  ],
  // 详情接口expand字段
  expand: "",
  init: {}, // 新增实体初始化字段
  // 详情渲染字段
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    const items = [
      {
        label: "区域名称",
        key: "name",
      },
      {
        label: "H5首页介绍",
        key: "info",
      },
    ];
    return items;
  },
};
